define('app/visualizations/DonutChart',['require','glu/layout','glu/itemView','glu/chartView','glu/grid/column/columnHeader','glu/grid/gridLayout','hbs!./GridHeaderView.hbs','app/visualizations/FormatFactory','app/visualizations/ValidationView','glu/util','glu/$','glu/collection','hbs!./DonutChart.hbs'],function(require) {
	'use strict';

	var Layout = require('glu/layout'),
		ItemView = require('glu/itemView'),
		ChartView = require('glu/chartView'),
		ColumnHeader = require('glu/grid/column/columnHeader'),
		Grid = require('glu/grid/gridLayout'),
		GridHeaderView = require('hbs!./GridHeaderView.hbs'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		ValidationView = require('app/visualizations/ValidationView'),
		_ = require('glu/util'),
		$ = require('glu/$'),
		Collection = require('glu/collection'),
		tmpl = require('hbs!./DonutChart.hbs');

	return Layout.extend({
		template: tmpl,

		regions: {
			'gridView': '#grid-view',
			'donutChart': '#donut-chart'
		},

		onShow: function() {
			this.activate();
		},

		onClose: function() {
			this.collection.reset();
		},

		activate: function() {
			var self = this,
				report = this.options.model,
				donutFilterValues = report.getOption('donutFilterValues') ? JSON.parse(report.getOption('donutFilterValues')) : {},
				selectedColumn = report.getOption('selectedColumn');

			self.selectedCount = 0;

			this.HeaderView = ColumnHeader.extend({
				initialize: function() {
					var col = this.model;

					if (!report.isGroupedAndAggregated()) {
						if (this.model.get('metadata').isMeasure) {
							this.model.set('columnTypeClass', ' measure');
						} else {
							this.model.set('columnTypeClass', ' dimension');
						}
					} else {
						if (this.model.get('metadata').aggregation) {
							this.model.set('columnTypeClass', ' aggregate');
						} else {
							this.model.set('columnTypeClass', ' group');
						}
					}
					var isFilter = _.filter(report.filter().filterCollection().models, function(filter) {
						if (filter.get('fieldObject')) {
							return filter.get('fieldObject').id === col.get('metadata').fieldId;
						} else {
							return filter.get('segmentId') === col.get('metadata').segmentId || filter.get('function') === col.get('metadata').function;
						}
					}).length > 0;

					if (isFilter) {
						this.model.set('isFilter', true);
					}

					this.listenTo(this, 'reorder', function() {
						self.model.trigger('change:reorder', self.updateColumnOrder());
					});
				},

				getTemplate: function() {
					return GridHeaderView;
				}
			});

			this.CellView = ItemView.extend({
				tagName: 'td',
				serializeData: function() {
					return this;
				},
				events: {
					'click .cell-wrap': 'reportClick'
				},
				reportClick: function(e) {
					self.onClickCell(e, this.options.column, this.model);
				},
				value: function() {
					var column = this.options.column;
					var format = column.get('format') || _.identity;
					return format(this.model.escape(column.get('field')));
				},
				template: function(view) {
					var isSelectedCell = self.isSelectedCell(view, donutFilterValues, selectedColumn);
					if (isSelectedCell) {
						self.selectedCount++;
						self.setSelectedCell(view.options.column, view.options.model.get(view.options.column.get('field')), {
							silent: true
						});
						self.renderChart();
					}

					return isSelectedCell ? '&nbsp;<div class="cell-wrap active">' + view.value() + '</div>' : '&nbsp;<div class="cell-wrap">' + view.value() + '</div>';
				}
			});

			this.columns = new Collection();
			this.collection = new Collection();

			self.attachListeners();

			self.refreshResults();
		},

		attachListeners: function() {
			var self = this;
			var report = this.model;

			self.listenTo(this.model, 'dataReceived', function() {
				self.refreshResults();
				self.$el.removeClass('is-loading');
				self.$el.find('.loading-indicator').remove();
			});

			self.listenTo(self.columns, 'change:width', function() {
				self.columns.each(function(column, index) {
					if (self.isInitalizingWidths) {
						return;
					}
					report.setOption('columnWidth:' + index, column.get('width'));
				});
			});

			window.setTimeout(function() {
				self.listenTo(self.columns, 'change:width', function() {
					report.trigger('change');
				});

				if (self.model.get('filter')) {
					self.listenTo(self.model.get('filter'), 'add remove change', function() {
						this.unsetSelectedCell();
					});
				}

				if (self.model.columns) {
					self.listenTo(self.model.columns(), 'add remove change', function() {
						self.unsetSelectedCell();
					});
				}
			}, 2000);

			self.listenTo(self.columns, 'change:sorted', function(column, direction) {
				var index = column.collection.indexOf(column);
				report.sortColumn(column.get('metadata'), direction);
				report.consumableResults().sort(index, direction);
				self.model.trigger('change:sorted');
				if (report.results().isMoreRowsAvailable) {
					_.defer(function() {
						report.run();
					});
				} else {
					_.defer(function() {
						self.addMoreRowsWarning();
					});
				}
			});

			// display a loading indicator whenever a report is run
			self.listenTo(report, 'run', function() {
				self.$el.addClass('is-loading');

				// ensure self icon is only displayed once
				if (!self.$el.find('.loading-indicator').length) {
					self.$el.append('<div class="loading-indicator">Loading&hellip;</div>');
				}
			});
		},

		updateColumnOrder: function() {
			var self = this;
			var newCollection = [];
			var i = 0;

			var findColumn = function(col) {
				if (col.get('function')) {
					return self.columns.models[i].get('metadata').function === col.get('function') &&
						self.columns.models[i].get('metadata').name === col.get('name') &&
						self.columns.models[i].get('metadata').isPercentage === col.get('isPercentage') &&
						self.columns.models[i].get('metadata').aggregation === col.get('aggregation');
				} else {
					return self.columns.models[i].get('metadata').fieldId === col.get('fieldId') &&
						self.columns.models[i].get('metadata').segmentId === col.get('segmentId') &&
						self.columns.models[i].get('metadata').isPercentage === col.get('isPercentage') &&
						self.columns.models[i].get('metadata').aggregation === col.get('aggregation');
				}
			};

			for (i = 0; i < this.columns.models.length; i++) {
				var match = _.find(this.model.get('columnCollection').models, findColumn);
				this.model.get('columnCollection').remove(match);
				if (match) {
					newCollection.push(match);
				}
			}

			this.model.get('columnCollection').reset(newCollection);
			this.model.trigger('change');
		},

		refreshResults: function() {
			var report = this.model;
			var gridResults = report.consumableResults();
			var self = this;

			if (gridResults) {
				self.columns.reset(gridResults.columns());
				self.collection.reset(gridResults.rows());

				self.columns.each(function(column, i) {
					var width = report.getOption('columnWidth:' + i);
					column.set('label', self.generateLabel(column));
					if (width) {
						column.set('width', width);
					}

					// Disable primary key columns
					var showColumn = column.get('metadata').name && column.get('metadata').name !== 'primaryColumn';
					// Using "column.set('condition', showColumn)" causes IE to break for an unknown reason
					column.attributes.condition = showColumn;
				});

				self.columns.last().set('width', 'auto');

				self.columns.each(function(column) {
					column.set('cellView', self.CellView);
					column.set('headerView', self.HeaderView);
				});

				self.addMoreRowsWarning();

				this.gridView.show(new Grid({
					filter: false,
					paginate: 'advanced',
					pageSize: 50,
					defaultColumnWidth: 'auto',
					collection: this.collection,
					columns: this.columns,
					resizable: true,
					draggable: true,
					disableDynamicColumnWidths: false,
					stickyFooter: true
				}));

				self.renderChart();
			}
		},

		generateLabel: function(column) {
			var output, total, formatter, aggregation, displayType;

			output = column.get('label');
			total = column.get('metadata').total;
			aggregation = column.get('metadata').aggregation;
			displayType = column.get('metadata').displayType;

			formatter = FormatFactory.formatterForType(column.get('metadata').fieldType, {
				'aggregation': aggregation,
				'displayType': displayType
			});

			if (!isNaN(total) && (!aggregation || aggregation === 'SUM' || aggregation === 'COUNT' || aggregation === 'COUNTD')) {
				if (column.get('metadata').fieldType === 'DATE' || column.get('metadata').fieldType === 'DATETIME') {
					return output + ' (' + total + ')';
				}
			}

			if (!isNaN(total) && (aggregation === 'COUNT' || aggregation === 'COUNTD') && column.get('metadata').fieldType === 'CURRENCY') {
				return output + ' (' + total + ')';
			} else {
				return output + ' (' + formatter(total) + ')';
			}
		},

		addMoreRowsWarning: function() {
			var self = this;
			if (this.model.results().isMoreRowsAvailable) {
				_.defer(function() {
					// ensure this icon is only displayed once
					if (!self.$el.find('.info .icon-warning').length) {
						self.$el.find('.info').append('<span class="icon-warning warning more-rows-warning" title="More records available, but not returned. Please adjust query or filter parameters to retrieve smaller result set"></span>');
					}
				});
			}
		},

		storeColumnArrangement: function() {
			var report = this.model;
			var headers = [];
			this.columns.each(function(c, i) {
				report.setColumnArrangement(c.get('metadata'), i);
				headers.push(c.get('metadata'));
			});
			this.model.consumableResults().rearrangeHeaders(headers);

		},

		setSelectedCell: function(col, value, silentObj) {
			var currentSelectedId = this.model.get('selectedId');

			// remember previous selection
			var previousSelection = {};
			previousSelection.isDirty = this.model.isDirty();
			previousSelection.selectedName = this.model.get('selectedName');
			previousSelection.selectedId = this.model.get('selectedId');
			previousSelection.selectedVal = this.model.get('selectedVal');
			previousSelection.selectedColType = this.model.get('selectedColType');
			previousSelection.selectedColTotal = this.model.get('selectedColTotal');
			previousSelection.selectedColAggregation = this.model.get('selectedColAggregation');
			previousSelection.selectedColIsPercentage = this.model.get('selectedColIsPercentage');
			previousSelection.selectedColumn = this.model.get('selectedId');
			previousSelection.donutFilterValues = this.model.getOption('donutFilterValues');

			// update to new selection
			this.model.set('selectedName', col.get('metadata').asName, silentObj);
			this.model.set('selectedId', col.get('field'), silentObj);
			this.model.set('selectedVal', parseFloat(value), silentObj);
			this.model.set('selectedColType', col.get('metadata').fieldType, silentObj);
			this.model.set('selectedColTotal', parseFloat(col.get('metadata').total), silentObj);
			this.model.set('selectedColAggregation', col.get('metadata').aggregation, silentObj);
			this.model.set('selectedColIsPercentage', col.get('metadata').isPercentage, silentObj);
			if (!silentObj) {
				this.model.trigger('change:setSelectedCell', currentSelectedId !== col.get('field'));
			}
			this.model.set('previousSelection', previousSelection, {
				silent: true
			});
		},

		unsetSelectedCell: function(silentObj) {
			this.model.set('selectedName', silentObj);
			this.model.set('selectedId', silentObj);
			this.model.set('selectedVal', silentObj);
			this.model.set('selectedColType', silentObj);
			this.model.set('selectedColTotal', silentObj);
			this.model.set('selectedColAggregation', silentObj);
			this.model.set('selectedColIsPercentage', silentObj);
			this.model.setOption('selectedColumn', silentObj);
			this.$el.find('.cell-wrap.active').removeClass('active');
			this.model.trigger('change:unsetSelectedCell');
		},

		onClickCell: function(e, col, row) {
			var report = this.options.model;
			var donutFilterValues = {};

			for (var i in row.attributes) {
				if (row.attributes.hasOwnProperty(i)) {
					var str = _.last(i.split('_'));
					var isAggregation = str === str.toUpperCase() && str.indexOf('-') === -1;

					if (!isAggregation) {
						donutFilterValues[i] = _.clone(row.attributes[i]);
					}
				}
			}

			this.$el.find('.grid .cell-wrap').removeClass('active');

			// Remove rolledUpFields
			for (var j in donutFilterValues) {
				if (j === 'rolledUpFields') {
					donutFilterValues[j] = undefined;
				}
			}

			report.setOption('selectedColumn', col.get('field'));
			this.setSelectedCell(col, row.get(col.get('field')));
			report.setOption('donutFilterValues', JSON.stringify(donutFilterValues));

			if (this.isValidDonut()) {
				$(e.target).addClass('active');
			} else {
				this.unsetSelectedCell();
			}

			this.renderChart();

			report.trigger('change');
		},

		renderChart: _.debounce(function() {
			var self = this,
				name = this.model.get('selectedName'),
				value = this.model.get('selectedVal'),
				type = this.model.get('selectedColType'),
				aggregation = this.model.get('selectedColAggregation'),
				isPercentage = this.model.get('selectedColIsPercentage');

			var formatOptions = {
				aggregation: aggregation
			};

			// Make sure we have valid numbers to work with
			if (self.isValidDonut()) {
				var options = {
					c3: {
						data: {
							columns: [
								['Val', self.getPercentageOfTotal()],
								['Total', 100 - self.getPercentageOfTotal()]
							],
							type: 'donut',
							order: null
						},
						interaction: {
							enabled: false
						},
						color: {
							pattern: ['#5591B1', '#c1c1c1']
						},
						donut: {
							label: {
								show: false
							},
							width: 14
						},
						size: {
							width: 130,
							height: 130
						},
						padding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0
						},
						legend: {
							hide: true
						}
					}
				};
				this.chartView = new ChartView(options);
				var $renderedEl = this.chartView.render().$el;
				$renderedEl.addClass('donut-chart-wrap');

				var $donutChart = $('<div/>');

				if (isPercentage) {
					$donutChart.addClass('percentage');
				}

				if (this.model.get('results').rows.length === 1 || aggregation === 'MEDIAN' || aggregation === 'STDDEV' || aggregation === 'AVG') {
					$donutChart.addClass('legacy-kpi');
					$donutChart.html('<div class="name">' + name + '</div>' +
						'<div class="value">' + FormatFactory.formatterForType(type, formatOptions)(value) + '</div>');
				} else {
					$donutChart.addClass('active');
					$donutChart.html($renderedEl);
					$donutChart.find('.donut-chart-wrap').show();
					$donutChart.append('<div class="percent">' + self.getPercentageOfTotal() + '<sup>%</sup></div>');
					$donutChart.append('<div class="name">' + name + '</div>');
					$donutChart.append('<div class="value">' + FormatFactory.formatterForType(type, formatOptions)(value) + '</div>');
				}

				self.donutChart.show(new ItemView({
					template: function() {
						return $donutChart;
					}
				}));
			} else {
				this.renderIncompatibleMessage();
			}

			this.model.trigger('donutRendered');
		}, 300),

		isSelectedCell: function(row, donutFilterValues, selectedColumn) {
			var clonedRow = _.clone(row.options.model.attributes);

			// Make sure the filters won't match more than 1 row
			if (_.size(donutFilterValues) !== this.getExpectedNumGroupedColumns()) {
				this.unsetSelectedCell();
				this.renderChart();
				return false;
			}

			// Remove rolledUpFields and the selected option
			if (!_.isEmpty(donutFilterValues)) {
				for (var i in donutFilterValues) {
					if (clonedRow[i] !== donutFilterValues[i]) {
						return false;
					}
				}
			}

			return row.options.column.get('field') === selectedColumn;
		},

		getExpectedNumGroupedColumns: function() {
			var self = this,
				output = 0;

			for (var i = 0; i < self.columns.models.length; i++) {
				if (!self.columns.models[i].get('metadata').aggregation) {
					output++;
				}
			}

			return output;
		},

		getPercentageOfTotal: function() {
			var output = (Math.round((this.model.get('selectedVal') / this.model.get('selectedColTotal') * 100) * 100) / 100).toFixed(1);

			output = output >= 100 ? 100.0 : output;

			return isNaN(output) ? 0 : output;
		},

		isValidDonut: function() {
			var name = this.model.get('selectedName'),
				id = this.model.get('selectedId'),
				val = this.model.get('selectedVal'),
				type = this.model.get('selectedColType'),
				total = this.model.get('selectedColTotal'),
				aggregation = this.model.get('selectedColAggregation');

			return name &&
				type &&
				aggregation &&
				id &&
				!isNaN(val) &&
				!isNaN(total);
		},

		renderIncompatibleMessage: function() {
			var self = this,
				validationView = new ValidationView({
					model: this.model
				});

			self.donutChart.show(new ItemView({
				template: function() {
					return validationView.render().el;
				}
			}));
		}
	});
});

